import CategoryManagerState from "@/modules/category-manager";
import TitleListState from "@/modules/title-list";
import { Paths } from "@/util/paths";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const ManagerChaptersRouteResolver = async function (to: Route, from: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);
	const actions: Promise<void>[] = [];
	if (to.params.id && !titleListModule.editedContentId.length) {
		actions.push(titleListModule.fetchContentDetails(to.params.id));
	} else if (!titleListModule.isParent) {
		// check if current title is parent and if not then redirect to text
		next(Paths.NotFound);
		return;
	}

	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}

	if (titleListModule.loadingPossibleChapters) {
		actions.push(new Promise(res => {
			setInterval(() => {
				if (!titleListModule.loadingPossibleChapters) {
					res();
				}
			}, 200);
		}));
		await Promise.all(actions);
	} else if (!titleListModule.possibleChapters.length) {
		await Promise.all(actions);
		await titleListModule.updatePossibleChildComponents(titleListModule.editedContentDetails.vcsLevelId);
	} else {
		await Promise.all(actions);
	}

	next();
};